/**
 * WordPress dependencies
 */
import { createBlock } from '@wordpress/blocks';
const transforms = {
  from: [{
    type: 'block',
    blocks: ['core/code'],
    transform: _ref => {
      let {
        content
      } = _ref;
      return createBlock('core/html', {
        content
      });
    }
  }]
};
export default transforms;
//# sourceMappingURL=transforms.js.map